module.exports = __webpack_public_path__ + "static/media/m-slimelab.500e9257.png";